import { Text as _Text } from '@bubble-ui/primitive-text';
import { View as _View } from '@bubble-ui/primitive-view';
export * from './flags';

/**
 * These are the currently supported exports by Bubble-UI
 */
import * as _DesignTokens from '@klarna/designtokens';
export { _DesignTokens as DesignTokens };
import * as _ParticleDesignVersions from '@bubble-ui/particle-design-versions';
export { _ParticleDesignVersions as ParticleDesignVersions };
export { ActionIconArrowBottom } from '@bubble-ui/icon-action-arrow-bottom';
export { ActionIconArrowLeft } from '@bubble-ui/icon-action-arrow-left';
export { ActionIconArrowRight } from '@bubble-ui/icon-action-arrow-right';
export { ActionIconArrowTop } from '@bubble-ui/icon-action-arrow-top';
export { ActionIconBookmark } from '@bubble-ui/icon-action-bookmark';
export { ActionIconCamera } from '@bubble-ui/icon-action-camera';
export { ActionIconCheckmark } from '@bubble-ui/icon-action-checkmark';
export { ActionIconChevronBottom } from '@bubble-ui/icon-action-chevron-bottom';
export { ActionIconChevronLeft } from '@bubble-ui/icon-action-chevron-left';
export { ActionIconChevronRight } from '@bubble-ui/icon-action-chevron-right';
export { ActionIconChevronTop } from '@bubble-ui/icon-action-chevron-top';
export { ActionIconClose } from '@bubble-ui/icon-action-close';
export { ActionIconCopy } from '@bubble-ui/icon-action-copy';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconDarkMode } from '@bubble-ui/icon-action-dark-mode';
export { ActionIconDeals } from '@bubble-ui/icon-action-deals';
export { ActionIconDownload } from '@bubble-ui/icon-action-download';
export { ActionIconEdit } from '@bubble-ui/icon-action-edit';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconEye } from '@bubble-ui/icon-action-eye';
export { ActionIconFile } from '@bubble-ui/icon-action-file';
export { ActionIconFilter } from '@bubble-ui/icon-action-filter';
export { ActionIconHeart } from '@bubble-ui/icon-action-heart';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconLanguage } from '@bubble-ui/icon-action-language';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconLike } from '@bubble-ui/icon-action-like';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconListView } from '@bubble-ui/icon-action-list-view';
export { ActionIconMinus } from '@bubble-ui/icon-action-minus';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconNewTab } from '@bubble-ui/icon-action-new-tab';
export { ActionIconPadlock } from '@bubble-ui/icon-action-padlock';
export { ActionIconPadlockUnlocked } from '@bubble-ui/icon-action-padlock-unlocked';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconPaperPlane } from '@bubble-ui/icon-action-paper-plane';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconPause } from '@bubble-ui/icon-action-pause';
export { ActionIconPermalink } from '@bubble-ui/icon-action-permalink';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconPin } from '@bubble-ui/icon-action-pin';
export { ActionIconPlaceholder } from '@bubble-ui/icon-action-placeholder';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconPlay } from '@bubble-ui/icon-action-play';
export { ActionIconPlus } from '@bubble-ui/icon-action-plus';
export { ActionIconRetweet } from '@bubble-ui/icon-action-retweet';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconScan } from '@bubble-ui/icon-action-scan';
export { ActionIconScroll } from '@bubble-ui/icon-action-scroll';
export { ActionIconSearch } from '@bubble-ui/icon-action-search';
export { ActionIconSearchGlobe } from '@bubble-ui/icon-action-search-globe';
export { ActionIconShare } from '@bubble-ui/icon-action-share';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconSquare } from '@bubble-ui/icon-action-square';
export { ActionIconStar } from '@bubble-ui/icon-action-star';
export { ActionIconTrash } from '@bubble-ui/icon-action-trash';
export { ActionIconUpload } from '@bubble-ui/icon-action-upload';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use Toast instead.
 */
export { AlertBanner } from '@bubble-ui/molecule-alert-banner';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use Toast with property status="error" instead.
 */
export { AlertBannerError } from '@bubble-ui/molecule-alert-banner-error';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use Toast with property status="success" instead.
 */
export { AlertBannerSuccess } from '@bubble-ui/molecule-alert-banner-success';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use Toast with property status="warning" instead.
 */
export { AlertBannerWarning } from '@bubble-ui/molecule-alert-banner-warning';
export { AlertBlock } from '@bubble-ui/molecule-alert-block';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use AlertBlock with property status="error" instead.
 */
export { AlertBlockError } from '@bubble-ui/molecule-alert-block-error';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use AlertBlock with property status="success" instead.
 */
export { AlertBlockSuccess } from '@bubble-ui/molecule-alert-block-success';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use AlertBlock with property status="warning" instead.
 */
export { AlertBlockWarning } from '@bubble-ui/molecule-alert-block-warning';
export { AnimationControlProvider, useAnimationControl } from '@bubble-ui/provider-animation-control';
export { ResponsiveProvider } from '@bubble-ui/provider-responsive';
export { ThemeNameProvider, useThemeName } from '@bubble-ui/provider-theme-name';
export { TouchableControlProvider, useTouchableControl } from '@bubble-ui/provider-touchable-control';
export { Avatar } from '@bubble-ui/molecule-avatar';
export { AvatarGroup } from '@bubble-ui/molecule-avatar-group';
export { InputMoney } from '@bubble-ui/molecule-input-money';
export { Badge } from '@bubble-ui/molecule-badge';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0. Use ItemGroup for the vertical variant or a group of Chips for the horizontal variant instead.
 */
export { BoxSelectorDetailed } from '@bubble-ui/molecule-segmented-control-box-selector-detailed';
export { Box } from '@bubble-ui/layout-box';
export { ButtonPrimary } from '@bubble-ui/molecule-button-primary';
export { ButtonQuaternary } from '@bubble-ui/molecule-button-quaternary';
export { ButtonRoundPrimary } from '@bubble-ui/molecule-button-round-primary';
export { ButtonRoundQuaternary } from '@bubble-ui/molecule-button-round-quaternary';
export { ButtonRoundSecondary } from '@bubble-ui/molecule-button-round-secondary';
export { ButtonRoundTertiary } from '@bubble-ui/molecule-button-round-tertiary';
export { ButtonSecondary } from '@bubble-ui/molecule-button-secondary';
export { ButtonTertiary } from '@bubble-ui/molecule-button-tertiary';
export { ButtonBrand } from '@bubble-ui/molecule-button-brand';
export { ChatBubble } from '@bubble-ui/molecule-chat-bubble';
export { Chip } from '@bubble-ui/molecule-chip';
export { constants } from './constants';
export { ContextMenuMain, ContextMenuNavigationItem, ContextMenuSeparator, ContextMenuSettingsItem } from '@bubble-ui/molecule-context-menu';
export { DatePickerMain as DatePicker } from '@bubble-ui/molecule-date-picker';
export { DatePickerDoubleMonth } from '@bubble-ui/molecule-date-picker';
export { Slider } from '@bubble-ui/molecule-slider';
export { DialogOptionsProvider } from '@bubble-ui/provider-dialog-options';
export { Consumer as DialogContentWidthConsumer } from '@bubble-ui/provider-dialog-content-width';
export { DialogUnwrapped } from '@bubble-ui/molecule-dialog-regular';
export { Dropdown } from '@bubble-ui/molecule-dropdown-regular';
export { Field } from '@bubble-ui/molecule-field-regular';
export { Fieldset } from '@bubble-ui/molecule-fieldset';
export { FieldMoney } from '@bubble-ui/molecule-field-money';
export { FieldSimple } from '@bubble-ui/molecule-field-simple';
export { Frame } from '@bubble-ui/molecule-frame';
export { FrameStack } from '@bubble-ui/molecule-frame-stack';
export { Grid } from '@bubble-ui/layout-grid';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconAssistant instead
 */
export { IconAgent } from '@bubble-ui/icon-agent';
export { IconAnnouncement } from '@bubble-ui/icon-announcement';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMore instead
 */
export { IconAppLauncher } from '@bubble-ui/icon-app-launcher';
export { IconArrowBottom } from '@bubble-ui/icon-arrow-bottom';
export { IconArrowLeft } from '@bubble-ui/icon-arrow-left';
export { IconArrowRight } from '@bubble-ui/icon-arrow-right';
export { IconArrowTop } from '@bubble-ui/icon-arrow-top';
export { IconAssets } from '@bubble-ui/icon-assets';
export { IconAssistant } from '@bubble-ui/icon-assistant';
export { IconAttachment } from '@bubble-ui/icon-attachment';
export { IconBackNavigation } from '@bubble-ui/icon-back-navigation';
export { IconBank } from '@bubble-ui/icon-bank';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconWallet instead
 */
export { IconBanksCards } from '@bubble-ui/icon-banks-cards';
export { IconBenefits } from '@bubble-ui/icon-benefits';
export { IconBookmark } from '@bubble-ui/icon-bookmark';
export { IconBrowserHistory } from '@bubble-ui/icon-browser-history';
export { IconBusinessProfile } from '@bubble-ui/icon-business-profile';
export { IconCalendar } from '@bubble-ui/icon-calendar';
export { IconCamera } from '@bubble-ui/icon-camera';
export { IconCancel } from '@bubble-ui/icon-cancel';
export { IconCancelCard } from '@bubble-ui/icon-cancel-card';
export { IconCart } from '@bubble-ui/icon-cart';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMoneyOut instead
 */
export { IconCashOut } from '@bubble-ui/icon-cash-out';
export { IconCellphone } from '@bubble-ui/icon-cellphone';
export { IconChatbot } from '@bubble-ui/icon-chatbot';
export { IconCheckmark } from '@bubble-ui/icon-checkmark';
export { IconChevronBottom } from '@bubble-ui/icon-chevron-bottom';
export { IconChevronLeft } from '@bubble-ui/icon-chevron-left';
export { IconChevronRight } from '@bubble-ui/icon-chevron-right';
export { IconChevronTop } from '@bubble-ui/icon-chevron-top';
export { IconClock } from '@bubble-ui/icon-clock';
export { IconClose } from '@bubble-ui/icon-close';
export { IconCollapseLeft } from '@bubble-ui/icon-collapse-left';
export { IconCollapseRight } from '@bubble-ui/icon-collapse-right';
export { IconCopy } from '@bubble-ui/icon-copy';
export { IconCreditCard } from '@bubble-ui/icon-credit-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconDarkMode instead
 */
export { IconDarkCanvas } from '@bubble-ui/icon-dark-canvas';
export { IconDarkMode } from '@bubble-ui/icon-dark-mode';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconClock or IconWarning instead
 */
export { IconDebt } from '@bubble-ui/icon-debt';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconTruck instead
 */
export { IconDelivery } from '@bubble-ui/icon-delivery';
export { IconDone } from '@bubble-ui/icon-done';
export { IconDownload } from '@bubble-ui/icon-download';
export { IconEdit } from '@bubble-ui/icon-edit';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMountain instead
 */
export { IconElephant } from '@bubble-ui/icon-elephant';
export { IconEntertainmentLeisure } from '@bubble-ui/icon-entertainment-leisure';
export { IconEnvelope } from '@bubble-ui/icon-envelope';
export { IconError } from '@bubble-ui/icon-error';
export { IconExclude } from '@bubble-ui/icon-exclude';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconClock or IconWarning instead
 */
export { IconExpired } from '@bubble-ui/icon-expired';
export { IconEye } from '@bubble-ui/icon-eye';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconAnnouncement instead
 */
export { IconFeedback } from '@bubble-ui/icon-feedback';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconHeart instead
 */
export { IconFeedbackConfirmation } from '@bubble-ui/icon-feedback-confirmation';
export { IconFile } from '@bubble-ui/icon-file';
export { IconFilter } from '@bubble-ui/icon-filter';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconInvestmentFund or IconInvestmentPurchase instead
 */
export { IconFinancial } from '@bubble-ui/icon-financial';
export { IconFoodBeverages } from '@bubble-ui/icon-food-beverages';
export { IconForwardNavigation } from '@bubble-ui/icon-forward-navigation';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconSnowflake instead
 */
export { IconFridge } from '@bubble-ui/icon-fridge';
export { IconGif } from '@bubble-ui/icon-gif';
export { IconGift } from '@bubble-ui/icon-gift';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { IconGlasses } from '@bubble-ui/icon-glasses';
export { IconGrid } from '@bubble-ui/icon-grid';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconGrid instead
 */
export { IconGridViewMode } from '@bubble-ui/icon-grid-view-mode';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconInformation instead
 */
export { IconGuidebook } from '@bubble-ui/icon-guidebook';
export { IconHamburger } from '@bubble-ui/icon-hamburger';
export { IconHandMoney } from '@bubble-ui/icon-hand-money';
export { IconHealth } from '@bubble-ui/icon-health';
export { IconHeart } from '@bubble-ui/icon-heart';
export { IconHelp } from '@bubble-ui/icon-help';
export { IconHome } from '@bubble-ui/icon-home';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconHome instead
 */
export { IconHouseholdUtilities } from '@bubble-ui/icon-household-utilities';
export { IconImageMissing } from '@bubble-ui/icon-image-missing';
export { IconInbox } from '@bubble-ui/icon-inbox';
export { IconInformation } from '@bubble-ui/icon-information';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconSearch instead
 */
export { IconInspect } from '@bubble-ui/icon-inspect';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconHandMoney or IconCalendar instead
 */
export { IconInstallment } from '@bubble-ui/icon-installment';
export { IconKeyboard } from '@bubble-ui/icon-keyboard';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use KlarnaLogoSingleLetter instead
 */
export { IconKlarnaK } from '@bubble-ui/icon-klarna-k';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconGlobe instead
 */
export { IconLanguage } from '@bubble-ui/icon-language';
export { IconLike } from '@bubble-ui/icon-like';
export { IconListViewMode } from '@bubble-ui/icon-list-view-mode';
export { IconLocation } from '@bubble-ui/icon-location';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { IconLogout } from '@bubble-ui/icon-logout';
export { IconMinus } from '@bubble-ui/icon-minus';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconCalendar instead
 */
export { IconMonthly } from '@bubble-ui/icon-monthly';
export { IconMore } from '@bubble-ui/icon-more';
export { IconNotification } from '@bubble-ui/icon-notification';
export { IconOrder } from '@bubble-ui/icon-order';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconUncategorized instead
 */
export { IconOther } from '@bubble-ui/icon-other';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMoneyOut instead
 */
export { IconOtherExpenses } from '@bubble-ui/icon-other-expenses';
export { IconPadlock } from '@bubble-ui/icon-padlock';
export { IconPadlockUnlocked } from '@bubble-ui/icon-padlock-unlocked';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconSend instead
 */
export { IconPaperPlane } from '@bubble-ui/icon-paper-plane';
export { IconPause } from '@bubble-ui/icon-pause';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconPause or IconIncome instead
 */
export { IconPausePayment } from '@bubble-ui/icon-pause-payment';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconTravels or IconMountain instead
 */
export { IconPension } from '@bubble-ui/icon-pension';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconProfile instead
 */
export { IconPerson } from '@bubble-ui/icon-person';
export { IconPhone } from '@bubble-ui/icon-phone';
export { IconPlaceholder } from '@bubble-ui/icon-placeholder';
export { IconPlay } from '@bubble-ui/icon-play';
export { IconPlus } from '@bubble-ui/icon-plus';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconSports instead
 */
export { IconProduct } from '@bubble-ui/icon-product';
export { IconProfile } from '@bubble-ui/icon-profile';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconProfile instead
 */
export { IconProfileAlternative } from '@bubble-ui/icon-profile-alternative';
export { IconQRCode } from '@bubble-ui/icon-qr-code';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMoneyIn instead
 */
export { IconReceiveMoney } from '@bubble-ui/icon-receive-money';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconCalendar instead
 */
export { IconRecurring } from '@bubble-ui/icon-recurring';
export { IconRefresh } from '@bubble-ui/icon-refresh';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconHandMoney instead
 */
export { IconReimbursements } from '@bubble-ui/icon-reimbursements';
export { IconReturn } from '@bubble-ui/icon-return';
export { IconRetweet } from '@bubble-ui/icon-retweet';
export { IconRocket } from '@bubble-ui/icon-rocket';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMoneyIn instead
 */
export { IconSalaryIncome } from '@bubble-ui/icon-salary-income';
export { IconSavings } from '@bubble-ui/icon-savings';
export { IconScale } from '@bubble-ui/icon-scale';
export { IconScan } from '@bubble-ui/icon-scan';
export { IconScissors } from '@bubble-ui/icon-scissors';
export { IconScreen } from '@bubble-ui/icon-screen';
export { IconSearch } from '@bubble-ui/icon-search';
export { IconSend } from '@bubble-ui/icon-send';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMoneyOut instead
 */
export { IconSendMoney } from '@bubble-ui/icon-send-money';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconStores instead
 */
export { IconServicePoint } from '@bubble-ui/icon-service-point';
export { IconSettings } from '@bubble-ui/icon-settings';
export { IconShare } from '@bubble-ui/icon-share';
export { IconShop } from '@bubble-ui/icon-shop';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconShop instead
 */
export { IconShopping } from '@bubble-ui/icon-shopping';
export { IconSign } from '@bubble-ui/icon-sign';
export { IconSize } from '@bubble-ui/icon-size';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconHeart instead
 */
export { IconSocialMedia } from '@bubble-ui/icon-social-media';
export { IconSpeechBubble } from '@bubble-ui/icon-speech-bubble';
export { IconStar } from '@bubble-ui/icon-star';
export { IconStores } from '@bubble-ui/icon-stores';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { IconStretch } from '@bubble-ui/icon-stretch';
export { IconSustainability } from '@bubble-ui/icon-sustainability';
export { IconTheme } from '@bubble-ui/icon-theme';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconTruck instead
 */
export { IconToDoorDelivery } from '@bubble-ui/icon-to-door-delivery';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconTruck instead
 */
export { IconToDoorDeliveryWithTimeslot } from '@bubble-ui/icon-to-door-delivery-with-timeslot';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconMoneyIn instead
 */
export { IconTopUp } from '@bubble-ui/icon-top-up';
export { IconTransfers } from '@bubble-ui/icon-transfers';
export { IconTrash } from '@bubble-ui/icon-trash';
export { IconTravels } from '@bubble-ui/icon-travels';
export { IconTruck } from '@bubble-ui/icon-truck';
export { IconUncategorized } from '@bubble-ui/icon-uncategorized';
export { IconUpload } from '@bubble-ui/icon-upload';
export { IconWallet } from '@bubble-ui/icon-wallet';
export { IconWarning } from '@bubble-ui/icon-warning';
export { ItemInformation } from '@bubble-ui/molecule-item-information';
export { ItemTouchable } from '@bubble-ui/molecule-item-touchable';
export { ItemGroup } from '@bubble-ui/molecule-item-group';
export { KlarnaAvatar } from '@bubble-ui/molecule-klarna-avatar';
export { KlarnaLogoFull } from '@bubble-ui/asset-klarna-logo-full';
export { KlarnaLogoSingleLetter } from '@bubble-ui/asset-klarna-logo-single-letter';
export { LinearGradient } from '@bubble-ui/atom-linear-gradient';
export { LineBreak } from '@bubble-ui/primitive-line-break';
export { Link } from '@bubble-ui/molecule-link';
export { List } from '@bubble-ui/molecule-list';
export { Loader } from '@bubble-ui/molecule-loader';
export { MaskedField } from '@bubble-ui/molecule-masked-field';
export { MenuTab } from '@bubble-ui/molecule-menu-tab';
export { NavBar } from '@bubble-ui/molecule-nav-bar';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconBanksCards } from '@bubble-ui/icon-navigation-banks-cards';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconDeals } from '@bubble-ui/icon-navigation-deals';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconDeliveries } from '@bubble-ui/icon-navigation-deliveries';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconFinancing } from '@bubble-ui/icon-navigation-financing';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconFinancingAlternative } from '@bubble-ui/icon-navigation-financing-alternative';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconGhostCard } from '@bubble-ui/icon-navigation-ghost-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconItems } from '@bubble-ui/icon-navigation-items';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconKlarnaCard } from '@bubble-ui/icon-navigation-klarna-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconLoyalty } from '@bubble-ui/icon-navigation-loyalty';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconMonthly } from '@bubble-ui/icon-navigation-monthly';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconOrders } from '@bubble-ui/icon-navigation-orders';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconPayments } from '@bubble-ui/icon-navigation-payments';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconReturns } from '@bubble-ui/icon-navigation-returns';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconShopInStore } from '@bubble-ui/icon-navigation-shop-in-store';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconSpendingPower } from '@bubble-ui/icon-navigation-spending-power';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconStores } from '@bubble-ui/icon-navigation-stores';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconStoresPlus } from '@bubble-ui/icon-navigation-stores-plus';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconSustainability } from '@bubble-ui/icon-navigation-sustainability';
export { PaymentLogoAmex } from '@bubble-ui/asset-payment-logo-amex';
export { PaymentLogoApplePay } from '@bubble-ui/asset-payment-logo-apple-pay';
export { PaymentLogoBankID } from '@bubble-ui/asset-payment-logo-bank-id';
export { PaymentLogoBankPlaceholder } from '@bubble-ui/asset-payment-logo-bank-placeholder';
export { PaymentLogoBankPlaceholderAlt } from '@bubble-ui/asset-payment-logo-bank-placeholder-alt';
export { PaymentLogoBillie } from '@bubble-ui/asset-payment-logo-billie';
export { PaymentLogoDiscover } from '@bubble-ui/asset-payment-logo-discover';
export { PaymentLogoKlarna } from '@bubble-ui/asset-payment-logo-klarna';
export { PaymentLogoMaestro } from '@bubble-ui/asset-payment-logo-maestro';
export { PaymentLogoMasterCard } from '@bubble-ui/asset-payment-logo-master-card';
export { PaymentLogoSwish } from '@bubble-ui/asset-payment-logo-swish';
export { PaymentLogoTuv } from '@bubble-ui/asset-payment-logo-tuv';
export { PaymentLogoVisa } from '@bubble-ui/asset-payment-logo-visa';
export { PaymentLogoVisaElectron } from '@bubble-ui/asset-payment-logo-visa-electron';
export { Preview } from '@bubble-ui/molecule-preview-simple';
export { ProgressBar } from '@bubble-ui/molecule-progress-bar';
export { Radio } from '@bubble-ui/molecule-radio';
export { RadioBullet } from '@bubble-ui/atom-radio-bullet';
export { RadioGroup } from '@bubble-ui/molecule-radio-group';

/**
 * @deprecated this component is outdated and will be removed with v9.0.0. Use ItemGroup with ItemTouchable instead.
 */
export { SelectorDirect } from '@bubble-ui/molecule-selector-direct';

/**
 * @deprecated this component is outdated and will be removed with v9.0.0. Use ItemGroup with ItemTouchable instead.
 */
export { SelectorLogo } from '@bubble-ui/molecule-selector-logo';

/**
 * @deprecated this component is outdated and will be removed with v9.0.0. Use ItemGroup with ItemTouchable instead.
 */
export { SelectorOptions } from '@bubble-ui/molecule-selector-options';

/**
 * @deprecated this component is outdated and will be removed with v9.0.0. Use ItemGroup with ItemTouchable instead.
 */
export { SelectorOptionsMulti } from '@bubble-ui/molecule-selector-options-multi';
export { Separator } from '@bubble-ui/atom-separator';
export { SpacerHorizontal } from '@bubble-ui/atom-spacer-horizontal';
export { SpacerVertical } from '@bubble-ui/atom-spacer-vertical';
export { Stepper } from '@bubble-ui/molecule-stepper';
export { Strong } from '@bubble-ui/atom-font-style-strong';
export { SwitchCheckbox } from '@bubble-ui/molecule-switch-checkbox';
export { SwitchToggle } from '@bubble-ui/molecule-switch-toggle';
export { Takeover } from '@bubble-ui/molecule-takeover';
export { Toast } from '@bubble-ui/molecule-toast';
export { Tooltip } from '@bubble-ui/molecule-tooltip';
export { TouchableFrame } from '@bubble-ui/molecule-touchable-frame';
export { TouchableIcon } from '@bubble-ui/molecule-touchable-icon';

/**
 * @deprecated this component is outdated and will be removed with v9.0.0. Use ItemGroup with ItemTouchable instead.
 */
export { Transaction } from '@bubble-ui/molecule-transaction';
export var View = _View;
export { Typography } from '@bubble-ui/molecule-typography';
export var Text = _Text;
export { Provider as DesignVersionProvider, useDesignVersion, withDesignVersion } from '@bubble-ui/provider-design-version';
/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconMute } from '@bubble-ui/icon-action-mute';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconUnmute } from '@bubble-ui/icon-action-unmute';
export { defaultColorVariables } from '@bubble-ui/particle-default-color-variables';
export { defaultTextStyles } from '@bubble-ui/particle-default-text-styles';
export { defaultFontFamilies } from '@bubble-ui/particle-default-font-families';
export { pancakeTheme } from '@bubble-ui/theme-pancake';
export { waffleTheme } from '@bubble-ui/theme-waffle';
export { whitelabelTheme } from '@bubble-ui/theme-whitelabel';
export { IconMute } from '@bubble-ui/icon-mute';
export { IconUnmute } from '@bubble-ui/icon-unmute';
export { IconAddContact } from '@bubble-ui/icon-add-contact';
export { IconClothing } from '@bubble-ui/icon-clothing';
export { IconElectronics } from '@bubble-ui/icon-electronics';
export { IconGroceries } from '@bubble-ui/icon-groceries';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconHandMoney or IconCreditCard instead
 */
export { IconAtmWithdrawal } from '@bubble-ui/icon-atm-withdrawal';
export { IconTax } from '@bubble-ui/icon-tax';
export { IconInterest } from '@bubble-ui/icon-interest';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconTax or IconCoins instead
 */
export { IconFee } from '@bubble-ui/icon-fee';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconCalendar instead
 */
export { IconUpcomingScheduled } from '@bubble-ui/icon-upcoming-scheduled';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconTransfer instead
 */
export { IconInstantAdd } from '@bubble-ui/icon-instant-add';
export { IconMoneyOut } from '@bubble-ui/icon-money-out';
export { IconMoneyIn } from '@bubble-ui/icon-money-in';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconCalendar or IconOneTimeCard instead
 */
export { IconOneTime } from '@bubble-ui/icon-one-time';
export { IconIncome } from '@bubble-ui/icon-income';
export { IconTransfer } from '@bubble-ui/icon-transfer';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconFee } from '@bubble-ui/icon-navigation-fee';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconInterest } from '@bubble-ui/icon-navigation-interest';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconMoneyIn } from '@bubble-ui/icon-navigation-money-in';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconAtmWithdrawal } from '@bubble-ui/icon-navigation-atm-withdrawal';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconMoneyOut } from '@bubble-ui/icon-navigation-money-out';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconTax } from '@bubble-ui/icon-navigation-tax';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconInstantAdd } from '@bubble-ui/icon-navigation-instant-add';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconInvestmentPurchase } from '@bubble-ui/icon-navigation-investment-purchase';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconInvestmentSale } from '@bubble-ui/icon-navigation-investment-sale';
export { IconInvestmentPurchase } from '@bubble-ui/icon-investment-purchase';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconInvestmentFund instead
 */
export { IconInvestmentSale } from '@bubble-ui/icon-investment-sale';
export { IconSports } from '@bubble-ui/icon-sports';
export { IconGaming } from '@bubble-ui/icon-gaming';
export { IconKidsFamily } from '@bubble-ui/icon-kids-family';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconBook instead
 */
export { IconBooks } from '@bubble-ui/icon-books';
export { IconTransport } from '@bubble-ui/icon-transport';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconOrder or IconPlus instead
 */
export { IconAddOrder } from '@bubble-ui/icon-add-order';
export { ActionIconGif } from '@bubble-ui/icon-action-gif';
export { IconInvestmentFund } from '@bubble-ui/icon-investment-fund';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconInvestmentFund } from '@bubble-ui/icon-navigation-investment-fund';
export { IconContactless } from '@bubble-ui/icon-contactless';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPrefilledDetails } from '@bubble-ui/colored-illustration-prefilled-details';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationMobileBankID } from '@bubble-ui/colored-illustration-mobile-bank-id';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationEnterName } from '@bubble-ui/colored-illustration-enter-name';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationEnterPin } from '@bubble-ui/colored-illustration-enter-pin';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationEnterBankAccount } from '@bubble-ui/colored-illustration-enter-bank-account';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationConfirmEmail } from '@bubble-ui/colored-illustration-confirm-email';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationVerifyYourIdentity } from '@bubble-ui/colored-illustration-verify-your-identity';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationTouchID } from '@bubble-ui/colored-illustration-touch-id';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSecurity } from '@bubble-ui/colored-illustration-security';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationIncreaseOrderValue } from '@bubble-ui/colored-illustration-increase-order-value';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationConsumerAppRational } from '@bubble-ui/colored-illustration-consumer-app-rational';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationDriveTraffic } from '@bubble-ui/colored-illustration-drive-traffic';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationNewBusiness } from '@bubble-ui/colored-illustration-new-business';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAutomaticUpdates } from '@bubble-ui/colored-illustration-automatic-updates';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSellerProtection } from '@bubble-ui/colored-illustration-seller-protection';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCancelCard } from '@bubble-ui/colored-illustration-cancel-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCreditRefusalRational } from '@bubble-ui/colored-illustration-credit-refusal-rational';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAutopay } from '@bubble-ui/colored-illustration-autopay';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSalary } from '@bubble-ui/colored-illustration-salary';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationEmptyState } from '@bubble-ui/colored-illustration-empty-state';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayNow } from '@bubble-ui/colored-illustration-pay-now';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationExternalBank } from '@bubble-ui/colored-illustration-external-bank';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPool } from '@bubble-ui/colored-illustration-pool';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationFreeCashWithdrawal } from '@bubble-ui/colored-illustration-free-cash-withdrawal';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationMonthlyInvoice } from '@bubble-ui/colored-illustration-monthly-invoice';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationBank } from '@bubble-ui/colored-illustration-bank';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationQuickTransfers } from '@bubble-ui/colored-illustration-quick-transfers';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationGift } from '@bubble-ui/colored-illustration-gift';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPushNotificationEmotional } from '@bubble-ui/colored-illustration-push-notification-emotional';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationErrorUFO } from '@bubble-ui/colored-illustration-error-ufo';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationMultipleCards } from '@bubble-ui/colored-illustration-multiple-cards';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationMailbox } from '@bubble-ui/colored-illustration-mailbox';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSuccess } from '@bubble-ui/colored-illustration-success';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationHighFive } from '@bubble-ui/colored-illustration-high-five';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationThumbsUp } from '@bubble-ui/colored-illustration-thumbs-up';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSearchError } from '@bubble-ui/colored-illustration-search-error';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSearchEmptyState } from '@bubble-ui/colored-illustration-search-empty-state';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSmooth } from '@bubble-ui/colored-illustration-smooth';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationBlockCard } from '@bubble-ui/colored-illustration-block-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationInstallments } from '@bubble-ui/colored-illustration-installments';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAppTemplate } from '@bubble-ui/colored-illustration-app-template';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationShopping } from '@bubble-ui/colored-illustration-shopping';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationBoostPurchasingPower } from '@bubble-ui/colored-illustration-boost-purchasing-power';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationInTransit } from '@bubble-ui/colored-illustration-in-transit';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationShoppingStore } from '@bubble-ui/colored-illustration-shopping-store';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSearchingOrders } from '@bubble-ui/colored-illustration-searching-orders';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationMerchantShipOrder } from '@bubble-ui/colored-illustration-merchant-ship-order';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAwaitingCourier } from '@bubble-ui/colored-illustration-awaiting-courier';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationTrackYourOrders } from '@bubble-ui/colored-illustration-track-your-orders';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationDelivered } from '@bubble-ui/colored-illustration-delivered';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPackage } from '@bubble-ui/colored-illustration-package';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationChatWithCustomerSupport } from '@bubble-ui/colored-illustration-chat-with-customer-support';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationProblem } from '@bubble-ui/colored-illustration-problem';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationChatWithAgent } from '@bubble-ui/colored-illustration-chat-with-agent';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationFAQ } from '@bubble-ui/colored-illustration-faq';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCustomerReferrals } from '@bubble-ui/colored-illustration-customer-referrals';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationBuyersProtection } from '@bubble-ui/colored-illustration-buyers-protection';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationMyOrders } from '@bubble-ui/colored-illustration-my-orders';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationReportProblem } from '@bubble-ui/colored-illustration-report-problem';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationReportReturn } from '@bubble-ui/colored-illustration-report-return';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationOtherQuestions } from '@bubble-ui/colored-illustration-other-questions';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAutomaticPayments } from '@bubble-ui/colored-illustration-automatic-payments';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationErrorExpiredCard } from '@bubble-ui/colored-illustration-error-expired-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCardGeneric } from '@bubble-ui/colored-illustration-card-generic';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCardKlarna } from '@bubble-ui/colored-illustration-card-klarna';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAddCard } from '@bubble-ui/colored-illustration-add-card';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCalendar } from '@bubble-ui/colored-illustration-calendar';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCards } from '@bubble-ui/colored-illustration-cards';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAlertBell } from '@bubble-ui/colored-illustration-alert-bell';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationDownPaymentEmpty } from '@bubble-ui/colored-illustration-down-payment-empty';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSatisfactionNegative } from '@bubble-ui/colored-illustration-satisfaction-negative';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAvatarA } from '@bubble-ui/colored-illustration-avatar-a';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAvatarB } from '@bubble-ui/colored-illustration-avatar-b';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAvatarC } from '@bubble-ui/colored-illustration-avatar-c';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationAvatarD } from '@bubble-ui/colored-illustration-avatar-d';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSnooze } from '@bubble-ui/colored-illustration-snooze';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSliceIt } from '@bubble-ui/colored-illustration-slice-it';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationRiskProtection } from '@bubble-ui/colored-illustration-risk-protection';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationErrorExplodingBalloon } from '@bubble-ui/colored-illustration-error-exploding-balloon';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationGlobalProducts } from '@bubble-ui/colored-illustration-global-products';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationErrorPaymentDenied } from '@bubble-ui/colored-illustration-error-payment-denied';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationErrorSpendingLimit } from '@bubble-ui/colored-illustration-error-spending-limit';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPhone } from '@bubble-ui/colored-illustration-phone';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationFaceId } from '@bubble-ui/colored-illustration-face-id';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationFast } from '@bubble-ui/colored-illustration-fast';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayDefault } from '@bubble-ui/colored-illustration-pay-default';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayNowOption } from '@bubble-ui/colored-illustration-pay-now-option';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayLater } from '@bubble-ui/colored-illustration-pay-later';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayOverTime } from '@bubble-ui/colored-illustration-pay-over-time';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayIn4 } from '@bubble-ui/colored-illustration-pay-in-4';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationPayIn3 } from '@bubble-ui/colored-illustration-pay-in-3';
export { IconNotificationOff } from '@bubble-ui/icon-notification-off';
export { ActionIconClock } from '@bubble-ui/icon-action-clock';
export { PaymentLogoBancontact } from '@bubble-ui/asset-payment-logo-bancontact';
export { PaymentLogoIdeal } from '@bubble-ui/asset-payment-logo-ideal';
export { PaymentLogoPrzelewy24 } from '@bubble-ui/asset-payment-logo-przelewy24';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotRefresh } from '@bubble-ui/spot-refresh';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotLike } from '@bubble-ui/spot-like';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotRocket } from '@bubble-ui/spot-rocket';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotCatalog } from '@bubble-ui/spot-catalog';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotHome } from '@bubble-ui/spot-home';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotHomeAppliances } from '@bubble-ui/spot-home-appliances';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotHomeSmallAppliances } from '@bubble-ui/spot-home-small-appliances';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotConstruction } from '@bubble-ui/spot-construction';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotSelfcare } from '@bubble-ui/spot-selfcare';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotFashion } from '@bubble-ui/spot-fashion';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotPhotography } from '@bubble-ui/spot-photography';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotPhone } from '@bubble-ui/spot-phone';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotSound } from '@bubble-ui/spot-sound';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotGaming } from '@bubble-ui/spot-gaming';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotEntertainment } from '@bubble-ui/spot-entertainment';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotComputers } from '@bubble-ui/spot-computers';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotTransportation } from '@bubble-ui/spot-transportation';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotTravel } from '@bubble-ui/spot-travel';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotSports } from '@bubble-ui/spot-sports';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotGarden } from '@bubble-ui/spot-garden';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotToysHobbies } from '@bubble-ui/spot-toys-hobbies';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotKidsFamily } from '@bubble-ui/spot-kids-family';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotPersonalFinances } from '@bubble-ui/spot-personal-finances';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotOfficeEquipment } from '@bubble-ui/spot-office-equipment';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationVirtualShoppingAppIcon } from '@bubble-ui/colored-illustration-virtual-shopping-app-icon';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationSales } from '@bubble-ui/colored-illustration-sales';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationExperts } from '@bubble-ui/colored-illustration-experts';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationStores } from '@bubble-ui/colored-illustration-stores';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationCalendarClock } from '@bubble-ui/colored-illustration-calendar-clock';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationRawMaterialExtraction } from '@bubble-ui/colored-illustration-raw-material-extraction';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationRawMaterialProcessing } from '@bubble-ui/colored-illustration-raw-material-processing';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationDeliveries } from '@bubble-ui/colored-illustration-deliveries';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationUseOfProduct } from '@bubble-ui/colored-illustration-use-of-product';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationRecycle } from '@bubble-ui/colored-illustration-recycle';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationProductAssembly } from '@bubble-ui/colored-illustration-product-assembly';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationRocket } from '@bubble-ui/colored-illustration-rocket';
export { IconCardLoyalty } from '@bubble-ui/icon-card-loyalty';
export { IconCardKlarna } from '@bubble-ui/icon-card-klarna';
export { IconDeals } from '@bubble-ui/icon-deals';
export { ActionIconRefresh } from '@bubble-ui/icon-action-refresh';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 */
export { ActionIconDislike } from '@bubble-ui/icon-action-dislike';
export { IconDislike } from '@bubble-ui/icon-dislike';
export { IconCurrent } from '@bubble-ui/icon-current';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconSavings instead
 */
export { IconSavingFixed } from '@bubble-ui/icon-saving-fixed';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use IconSavings instead
 */
export { IconSavingFlex } from '@bubble-ui/icon-saving-flex';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Use ActionIconWarning or ActionIconError instead
 */
export { ActionIconWarningError } from '@bubble-ui/icon-action-warning-error';
export { ActionIconInformation } from '@bubble-ui/icon-action-information';
export { ActionIconSuccess } from '@bubble-ui/icon-action-success';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotRocketGrey } from '@bubble-ui/spot-rocket-grey';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotDisputesReturns } from '@bubble-ui/spot-disputes-returns';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/spots
 */
export { SpotDeliveries } from '@bubble-ui/spot-deliveries';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconGoalBetter } from '@bubble-ui/icon-navigation-goal-better';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconPlusOne } from '@bubble-ui/icon-navigation-plus-one';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconRoundUp } from '@bubble-ui/icon-navigation-round-up';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconLastBite } from '@bubble-ui/icon-navigation-last-bite';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconPayYourselfFirst } from '@bubble-ui/icon-navigation-pay-yourself-first';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconRollDice } from '@bubble-ui/icon-navigation-roll-dice';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIcon365Challenge } from '@bubble-ui/icon-navigation-365-challenge';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconCreateYourOwn } from '@bubble-ui/icon-navigation-create-your-own';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/navigation-icons
 */
export { NavigationIconPlaceholder } from '@bubble-ui/icon-navigation-placeholder';
export { PaymentLogoBlik } from '@bubble-ui/asset-payment-logo-blik';
export { PaymentLogoPrzelewy24Alt } from '@bubble-ui/asset-payment-logo-przelewy24-alt';
export { ComponentOverridesProvider, ComponentOverridesConsumer, useComponentOverridesProvider } from '@bubble-ui/provider-component-overrides';

/**
 * @deprecated this component is outdated and will be removed with v8.0.0
 * Read more at https://bubble-ui.klarna.net/#components/colored-illustrations
 */
export { ColoredIllustrationBankError } from '@bubble-ui/colored-illustration-bank-error';
export { ActionIconEnvelope } from '@bubble-ui/icon-action-envelope';
export { ActionIconError } from '@bubble-ui/icon-action-error';
export { ActionIconMessage } from '@bubble-ui/icon-action-message';
export { ActionIconPhone } from '@bubble-ui/icon-action-phone';
export { ActionIconWarning } from '@bubble-ui/icon-action-warning';
export { IconAI } from '@bubble-ui/icon-ai';
export { IconAIChat } from '@bubble-ui/icon-ai-chat';
export { IconBalloonBroken } from '@bubble-ui/icon-balloon-broken';
export { IconBeauty } from '@bubble-ui/icon-beauty';
export { IconBook } from '@bubble-ui/icon-book';
export { IconBudget } from '@bubble-ui/icon-budget';
export { IconCalculator } from '@bubble-ui/icon-calculator';
export { IconCar } from '@bubble-ui/icon-car';
export { IconCards } from '@bubble-ui/icon-cards';
export { IconChange } from '@bubble-ui/icon-change';
export { IconChoice } from '@bubble-ui/icon-choice';
export { IconCoins } from '@bubble-ui/icon-coins';
export { IconFaceID } from '@bubble-ui/icon-face-id';
export { IconFactory } from '@bubble-ui/icon-factory';
export { IconFashion } from '@bubble-ui/icon-fashion';
export { IconFlag } from '@bubble-ui/icon-flag';
export { IconFlight } from '@bubble-ui/icon-flight';
export { IconFolder } from '@bubble-ui/icon-folder';
export { IconGlobe } from '@bubble-ui/icon-globe';
export { IconGraph } from '@bubble-ui/icon-graph';
export { IconHammer } from '@bubble-ui/icon-hammer';
export { IconHelmet } from '@bubble-ui/icon-helmet';
export { IconHourglass } from '@bubble-ui/icon-hourglass';
export { IconIron } from '@bubble-ui/icon-iron';
export { IconLink } from '@bubble-ui/icon-link';
export { IconMessageQuestion } from '@bubble-ui/icon-message-question';
export { IconMicrophone } from '@bubble-ui/icon-microphone';
export { IconMountain } from '@bubble-ui/icon-mountain';
export { IconMouse } from '@bubble-ui/icon-mouse';
export { IconMovie } from '@bubble-ui/icon-movie';
export { IconOneTimeCard } from '@bubble-ui/icon-one-time-card';
export { IconReceipt } from '@bubble-ui/icon-receipt';
export { IconRing } from '@bubble-ui/icon-ring';
export { IconSale } from '@bubble-ui/icon-sale';
export { IconSelfCare } from '@bubble-ui/icon-self-care';
export { IconShield } from '@bubble-ui/icon-shield';
export { IconShieldCheckmark } from '@bubble-ui/icon-shield-checkmark';
export { IconSnowflake } from '@bubble-ui/icon-snowflake';
export { IconSound } from '@bubble-ui/icon-sound';
export { IconSpeedmeter } from '@bubble-ui/icon-speedmeter';
export { IconStopwatch } from '@bubble-ui/icon-stopwatch';
export { IconSuccess } from '@bubble-ui/icon-success';
export { IconTarget } from '@bubble-ui/icon-target';
export { IconTelescope } from '@bubble-ui/icon-telescope';
export { IconTouchID } from '@bubble-ui/icon-touch-id';
export { IconTrophy } from '@bubble-ui/icon-trophy';
export { useInteractiveStateCombined, useInteractiveStateCombinedWithOverrides } from '@bubble-ui/hook-use-interactive-state';
export { IconOpenExternal } from '@bubble-ui/icon-open-external';
export { IconSavedList } from '@bubble-ui/icon-saved-list';
export { IconTabs } from '@bubble-ui/icon-tabs';
export { IconTrending } from '@bubble-ui/icon-trending';
export { ActionIconOpenExternal } from '@bubble-ui/icon-action-open-external';
export { PaymentLogoSwishAlt } from '@bubble-ui/asset-payment-logo-swish-alt';
export { ActionIconBank } from '@bubble-ui/icon-action-bank';
export { formatMoney } from '@bubble-ui/util-get-currency-details';
export { ActionIconCashback } from '@bubble-ui/icon-action-cashback';
export { IconCalendarCheckbox } from '@bubble-ui/icon-calendar-checkbox';
export { IconCashback } from '@bubble-ui/icon-cashback';
export { IconPasskey } from '@bubble-ui/icon-passkey';
export { IconPayIn3 } from '@bubble-ui/icon-pay-in3';
export { IconPayIn4 } from '@bubble-ui/icon-pay-in4';
//# sourceMappingURL=index.js.map